class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCountDesktop').innerHTML;
    const pagination = new DOMParser().parseFromString(html, 'text/html').getElementById('Pagination').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const containerPagination = document.getElementById('Pagination');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    if (containerPagination) {
      containerPagination.innerHTML = pagination;
      containerPagination.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      if(document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`) != null)
        document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop', '.active-facets-desktop-2'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    const activeFilters = document.getElementById("ActiveFacetFilters");
    if(activeFilters.children.length == 1){
      activeFilters.style.border = "none";
    } else {
      activeFilters.style.borderBottom = "1px solid rgba(0, 0, 0, 0.10)";
    }

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  //Custom
  createSearchParamsWithoutDoubles(searchParams){
    var queryStringParams = searchParams.split('&');
    //Remove doubles and empty values
    var uniqueParams = queryStringParams.filter(function(elem, index, self) {
      return index === self.indexOf(elem);
    }).filter(item => item)
    
    return uniqueParams.join('&')
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            //Custom
            var ignoreFilter = false;
            //Check if filter already used
            forms.forEach((f) => {
              if(f.includes('filter') && form.id === 'FacetFiltersForm'){
                ignoreFilter = true;
              }
            })
            if(!ignoreFilter){
              forms.push(this.createSearchParams(form));
            }
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      var searchParams = this.createSearchParamsWithoutDoubles(forms.join('&'));
      this.onSubmitForm(searchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
    this.initPriceRange();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  initPriceRange() {
    let priceGap = 1;
    this.setPriceFields(false, null, priceGap);
    const priceInput = this.querySelectorAll(".price-input input");
    priceInput.forEach((input) => {
      let continueInput = true;
      input.addEventListener("keydown", (e) => {
        var key = e.keyCode || e.charCode;
        continueInput = !(key == 8 || key == 46 || e.code == "Backspace" || e.key == "Backspace");
      });
      input.addEventListener("input", (e) => {
        if(continueInput) {
          this.setPriceFields(true, e, priceGap);
        }
      });
    });

    const rangeInput = document.querySelectorAll(".range-input input")
    rangeInput.forEach((input) => {
      input.addEventListener("input", (e) => {
        const rangeInput = this.querySelectorAll(".range-input input"),
            priceInput = this.querySelectorAll(".price-input input"),
            range = this.querySelector(".slider .progress"),
            sliderVal = this.querySelectorAll(".slider-prices .slider-val");

        let minVal = parseInt(rangeInput[0].value),
            maxVal = parseInt(rangeInput[1].value),
            maxRange = parseInt(rangeInput[1].max);

        if (!(maxVal - minVal < priceGap)) {
          if (e.target.className.includes("range-min")) {
            priceInput[0].value = minVal;
            sliderVal[0].innerText = minVal;
            range.style.left = (minVal / maxRange) * 100 + "%";
            if(isNaN(parseFloat(priceInput[1].value))){
              priceInput[1].value = maxRange;
              sliderVal[1].innerText = maxRange;
              range.style.right = 100 - (maxRange / maxRange) * 100 + "%";
            }
          } else {
            priceInput[1].value = maxVal;
            sliderVal[1].innerText = maxVal;
            range.style.right = 100 - (maxVal / maxRange) * 100 + "%";
            if(isNaN(parseFloat(priceInput[0].value))){
              priceInput[0].value = 0;
              sliderVal[0].innerText = 0;
              range.style.left = (Math.round(0) / maxRange) * 100 + "%";;
            }
          }
        }
      });
    });
  }

  setPriceFields(input, e, priceGap) {
    const rangeInput = this.querySelectorAll(".range-input input"),
        priceInput = this.querySelectorAll(".price-input input"),
        progress = this.querySelector(".slider .progress"),
        sliderVal = this.querySelectorAll(".slider-prices .slider-val");

    let minPrice = parseFloat(priceInput[0].value),
        maxPrice = parseFloat(priceInput[1].value),
        maxRange = parseInt(rangeInput[1].max),
        roundedMin = Math.round(minPrice),
        roundedMax = Math.round(maxPrice);

    if(!input && !isNaN(minPrice) && !isNaN(maxPrice)){
      sliderVal[0].innerText = minPrice.toString().replace(".", ",");
      rangeInput[0].value = roundedMin;
      sliderVal[1].innerText = maxPrice.toString().replace(".", ",");
      rangeInput[1].value = roundedMax;
      progress.style.left = (roundedMin / maxRange) * 100 + "%";
      progress.style.right = 100 - (roundedMax / maxRange) * 100 + "%";
    } else if(!isNaN(minPrice) || !isNaN(maxPrice)) {
      if (isNaN(minPrice)) {
        minPrice = 0;
        priceInput[0].value = minPrice;
      }
      if(isNaN(maxPrice)){
        maxPrice = maxRange;
        priceInput[1].value = maxPrice;
      }
      rangeInput[0].value = Math.round(minPrice);
      rangeInput[0].classList.remove("hidden");
      rangeInput[1].value = Math.round(maxPrice);
      rangeInput[1].classList.remove("hidden");
      progress.style.left = (Math.round(minPrice) / maxRange) * 100 + "%";
      progress.style.right = 100 - (Math.round(maxPrice) / maxRange) * 100 + "%";
    } else if(!input) {
      sliderVal[0].innerText = 0;
      sliderVal[1].innerText = Math.round(maxRange);
    } else {
      if (maxPrice - minPrice >= priceGap && maxPrice <= maxRange) {
        if (e.target.className.includes("input-min")) {
          rangeInput[0].value = roundedMin;
          progress.style.left = (roundedMin / maxRange) * 100 + "%";
        } else {
          rangeInput[1].value = roundedMax;
          progress.style.right = 100 - (roundedMax / maxRange) * 100 + "%";
        }
      }
    }

    if(input){
      sliderVal[0].innerText = minPrice.toString().replace(".", ",");
      sliderVal[1].innerText = maxPrice.toString().replace(".", ",");
    }
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
